module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/section04_08_american-village-af4b8cbcae49947837ca43ae84bb89f4.jpg";